import {
  EDITOR_UPLOAD_IMAGE_FROM_URL_BEGIN,
  EDITOR_UPLOAD_IMAGE_FROM_URL_SUCCESS,
  EDITOR_UPLOAD_IMAGE_FROM_URL_FAILURE,
  EDITOR_UPLOAD_IMAGE_FROM_URL_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function uploadImageFromUrl(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_UPLOAD_IMAGE_FROM_URL_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/assets/${projectId}/url-upload`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: EDITOR_UPLOAD_IMAGE_FROM_URL_SUCCESS,
              data: res.data,
            });
            toast.success('Asset Uploaded Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: EDITOR_UPLOAD_IMAGE_FROM_URL_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Upload Failed: ${errMsg} `);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EDITOR_UPLOAD_IMAGE_FROM_URL_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Upload Failed: ${errMsg} `);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUploadImageFromUrlError() {
  return {
    type: EDITOR_UPLOAD_IMAGE_FROM_URL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_UPLOAD_IMAGE_FROM_URL_BEGIN:
      return {
        ...state,
        uploadImageFromUrlPending: true,
        uploadImageFromUrlError: null,
      };

    case EDITOR_UPLOAD_IMAGE_FROM_URL_SUCCESS:
      return {
        ...state,
        uploadImageFromUrlPending: false,
        uploadImageFromUrlError: null,
        assets: action.data,
      };

    case EDITOR_UPLOAD_IMAGE_FROM_URL_FAILURE:
      return {
        ...state,
        uploadImageFromUrlPending: false,
        uploadImageFromUrlError: action.data.error,
      };

    case EDITOR_UPLOAD_IMAGE_FROM_URL_DISMISS_ERROR:
      return {
        ...state,
        uploadImageFromUrlError: null,
      };

    default:
      return state;
  }
}
